<script setup lang="ts">
import { computed } from 'vue';

import { BaseIcon } from '@magma-app/magma-lapilli';

const props = defineProps<{
  headerUrl: string;
  showBack: boolean;
}>();

const emit = defineEmits<{
  (event: 'back'): void;
}>();

const containerClass = computed(() => [
  'mx-auto max-w-5xl bg-cover bg-center lg:rounded-[10px]',
  {
    'h-[23vh] max-h-96': Boolean(props.headerUrl),
    'relative min-h-[44px]': props.showBack,
  },
]);

const backgroundStyle = computed(() => ({
  backgroundImage: `url('${props.headerUrl}')`,
}));
</script>

<template>
  <div :class="containerClass" :style="backgroundStyle">
    <BaseIcon
      v-if="showBack"
      class="absolute left-4 top-4 rounded-full bg-background-subtle p-1.5 lg:hidden"
      color="#5F6C85"
      icon="arrow-left"
      @click="emit('back')"
    />
  </div>
</template>
